module.exports = __webpack_public_path__ + "img/menu6.19ace747.png";